import React from 'react';
import { Switch, Route } from 'react-router';

import ScriptsPage from './ScriptsPage';
import { Studio } from '../../../components';
import RouteGetter from '../../../routes/RouteGetter';

const Scripts = () => {
  return (
    <Switch>
      <Route exact path={RouteGetter.get('project').scriptsPath()}>
        <ScriptsPage />
      </Route>
      <Route path={RouteGetter.get('project').studioPath()}>
        <Studio />
      </Route>
    </Switch>
  );
};

export default Scripts;
